import { Checkbox, FormControlLabel, Radio, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import InputTextField from '../../../../components/input/inputTextField';

export default function FormLesson({ form, items, setItems, selectedIndex, setSelectedIndex }: any) {

    return (
        <div style={{ width: '100%' }}>
            {/* {data?.length > 0 && <Typography >จำนวนหน้า: {selectedIndex + 1}/{data?.length}</Typography>} */}


            {form?.course_form_subject?.filter((_: any, index: number) => selectedIndex === index)?.map((itemDetail: any, index: number) => {
                return (
                    <div>
                        <div >
                            {itemDetail?.online_course_form_subject_type === "SINGLE_CHOICE" &&
                                <div style={{
                                    height: 'auto',
                                    width: '100%',

                                    overflow: 'hidden'

                                }}>
                                    <div style={{
                                        display: "flex", flexDirection: "column", gap: '10px'
                                    }}>
                                        <Typography variant='h5'>{itemDetail?.online_course_form_subject}</Typography>
                                        <div style={{ display: "flex", flexDirection: "column", gap: '10px' }}>
                                            {itemDetail?.choices?.map((itemChoose: any, ix: number) => {
                                                return (
                                                    <div key={ix} style={{ backgroundColor: "#F2F2F2", padding: '10px 16px', borderRadius: "50px" }}>
                                                        <FormControlLabel
                                                            checked={items?.find((x: any) => x?.id_online_course_form_choice === itemChoose?.id_online_course_form_choice)?.is_true || ''}
                                                            onChange={(nextChecked: any) => {
                                                                setItems((prevData: any) =>
                                                                    prevData.map((p: any) =>
                                                                        p.id_online_course_form_choice === itemChoose?.id_online_course_form_choice ? {
                                                                            ...p,
                                                                            is_true: nextChecked.target.checked,
                                                                        } : p?.id_online_course_form_subject === itemChoose?.id_online_course_form_subject && (p?.online_course_form_choice_type === "SINGLE_CHOICE") ? {
                                                                            ...p,
                                                                            is_true: false,
                                                                        } : p
                                                                    )
                                                                );
                                                                // setSelectedIndex(index + 1)
                                                            }}
                                                            control={<Radio />} label={itemChoose?.online_course_form_choice} />
                                                    </div>
                                                )
                                            })}
                                        </div>

                                    </div>

                                </div>
                            }
                            {itemDetail?.online_course_form_subject_type === "MULTI_CHOICE" &&
                                <div style={{
                                    height: 'auto',
                                    width: '100%',

                                    overflow: 'hidden'

                                }}>
                                    <div style={{
                                        display: "flex", flexDirection: "column", gap: '10px'
                                    }}>
                                        <Typography variant='h5'>{itemDetail?.online_course_form_subject}</Typography>
                                        <div style={{ display: "flex", flexDirection: "column", gap: '10px' }}>
                                            {itemDetail?.choices?.map((itemChoose: any, ix: number) => {
                                                return (
                                                    <div key={ix} style={{ backgroundColor: "#F2F2F2", padding: '10px 16px', borderRadius: "50px" }}>
                                                        <FormControlLabel
                                                            checked={items?.find((x: any) => x?.id_online_course_form_choice === itemChoose?.id_online_course_form_choice)?.is_true || ''}
                                                            onChange={(nextChecked: any) => {

                                                                setItems((prevData: any) =>
                                                                    prevData.map((p: any) =>
                                                                        p.id_online_course_form_choice === itemChoose?.id_online_course_form_choice ? {
                                                                            ...p,
                                                                            is_true: nextChecked.target.checked,
                                                                        } : p
                                                                    )
                                                                );
                                                                // setSelectedIndex(index + 1)
                                                            }}
                                                            control={<Checkbox />} label={itemChoose?.online_course_form_choice} />
                                                    </div>
                                                )
                                            })}
                                        </div>

                                    </div>

                                </div>
                            }

                            {itemDetail?.online_course_form_subject_type === "DESCRIPTION" &&
                                <div style={{
                                    height: 'auto',
                                    width: '100%',
                                    overflow: 'hidden'

                                }}>
                                    <div style={{
                                        display: "flex", flexDirection: "column", gap: '10px'
                                    }}>
                                        <Typography variant='h5'>{itemDetail?.online_course_form_subject}</Typography>
                                        <div style={{ display: "flex", flexDirection: "column", gap: '10px' }}>
                                            {itemDetail?.choices?.map((itemChoose: any, ix: number) => {
                                                return (
                                                    <InputTextField
                                                        value={items?.find((x: any) => x?.id_online_course_form_choice === itemChoose?.id_online_course_form_choice)?.online_course_form_answer_detail || ''}
                                                        onchange={e => {
                                                            setItems((prevData: any) =>
                                                                prevData.map((p: any) =>
                                                                    p.id_online_course_form_choice === itemChoose?.id_online_course_form_choice ? {
                                                                        ...p,
                                                                        online_course_form_answer_detail: e.target.value
                                                                    } : p
                                                                )
                                                            );
                                                        }}
                                                        multiline
                                                        inputHeight={'auto'}
                                                        minRow={6}
                                                    />
                                                )
                                            })}
                                        </div>

                                    </div>
                                </div>
                            }
                        </div>

                        <div style={{ flexDirection: "row" }}>
                            {/* <div style={{ width: `${100 / 2} %`, padding: 8 }}>
                            {selectedIndex > 0 && <ButtonCustom sizeUp={size} onPress={() => {
                                setSelectedIndex(itemDetail.index - 1)
                                // AsyncStorage.setItem('selectedIndex', (itemDetail.index - 1).toString())
                            }}
                                buttonName={'ข้อก่อนหน้า'} style={{ width: '100%', backgroundColor: color ? '#000000' : "#76B495", borderColor: color ? '#000000' : "#76B495" }} />}
                        </div>
                        <div style={{ width: `${100 / 2} %`, padding: 8 }}>
                            {selectedIndex < (data?.length - 1) && <ButtonCustom sizeUp={size} onPress={() => {
                                setSelectedIndex(itemDetail.index + 1)
                                // AsyncStorage.setItem('selectedIndex', (itemDetail.index + 1).toString())
                            }}
                                buttonName={'ข้อถัดไป'} style={{ width: '100%', backgroundColor: color ? '#000000' : "#1A543B", borderColor: color ? '#000000' : "#1A543B" }} />}
                        </div> */}
                        </div>
                    </div>


                )
            })}
        </div>
    )
}
